import { StringUnionKeyAsValue } from '../ts/helpers/TypescriptHelpers';

export type CatalogContentType = 'database' | 'table';

export const CatalogContentTypes: StringUnionKeyAsValue<CatalogContentType> = {
  database: 'database',
  table: 'table',
};
